module.exports = __webpack_public_path__ + "img/co2.2f27dc29.svg";